export const Themes = {
  MATRIX: 'matrix',
  ALLOY: 'alloy'
};
